import { AppDispatch, RootState } from '../../store';
import {
  addMessage,
  incrementDailyMessageCount,
  loadConversation,
  addToHistory,
  setConversationStats,
  clearInputMessage,
  createErrorMessage,
  updateMessageStatus,
} from './slice';
import { userChatToMessage } from './chatToMessage';
import { ChatRequestData } from '../../socket/publishers/sendUserChatMessage';
import { MessageStatus, ConversationStatus } from './types';
import { sendUserChatMessage } from '../../socket/publishers/sendUserChatMessage';

const submitInputMessage = () => async (dispatch: AppDispatch, getState: () => RootState) => {
  const state = getState();
  const text = state.chat.inputMessage;
  if (!text.trim()) return;

  const { conversation, formValues } = state.chat;
  const userMessage = {
    ...userChatToMessage(text, conversation),
    status: MessageStatus.Sending,
  };
  dispatch(addMessage(userMessage));
  dispatch(incrementDailyMessageCount());

  try {
    const requestData: ChatRequestData = {
      query: text,
      conversationId: conversation?.id || undefined,
      model: formValues.model,
      topK: formValues.topK,
      relevancePercent: formValues.relevancePercent,
      ragMode: formValues.ragMode,
      traceTag: formValues.traceTag,
      forceQueryType: formValues.forceQueryType,
      filteredCompanyIds: formValues.filteredCompanyIds,
    };

    const response = await sendUserChatMessage(requestData);

    if (response.conversation) {
      const messageIndex = response.conversation.messages.length - 1;
      const updatedConversation = {
        ...response.conversation,
        status: ConversationStatus.Answering,
      };
      dispatch(loadConversation(updatedConversation));
      if (!conversation) {
        dispatch(addToHistory(updatedConversation));
      }
      dispatch(
        updateMessageStatus({
          conversationId: response.conversation.id,
          messageIndex,
          status: MessageStatus.Sent,
        }),
      );
    } else if (response.dailyMessageCount) {
      dispatch(
        setConversationStats({
          dailyMessageCount: response.dailyMessageCount,
          limitHitTime: response.limitHitTime,
          resetTime: response.resetTime,
        }),
      );
    } else {
      throw new Error(`Failed to send message: ${response.error}`);
    }

    dispatch(clearInputMessage());
    // All other state updates will happen through socket events
  } catch (error) {
    const errorMessage = createErrorMessage(
      'Sorry, there was an error processing your request. Please try again.',
    );
    dispatch(addMessage(errorMessage));
    throw error;
  }
};

export { submitInputMessage };
export default submitInputMessage;
